export default function scrollToElement(element: HTMLElement, offsetTop: number = 40) {
    const elementOffset: number = element.getBoundingClientRect().top;

    window.scrollBy({
        top: elementOffset - offsetTop,
        left: 0,
        behavior: 'smooth',
    });
}
